var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "margin-1 pega-table-sp" },
    [
      _c("h6", [_vm._v("■職種設定")]),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: _vm.offerPointTitle } },
        [
          !_vm.isCompanyStaffAccess
            ? _c("job-content-table-outline", {
                attrs: {
                  title: "給与コード",
                  value: _vm.jobCategorySettings.offerPoint.salary,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: {
              title: "職種[1]",
              value: _vm.jobCategorySettings.offerPoint.jobName1,
            },
          }),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: {
              title: "職種[2]",
              value: _vm.jobCategorySettings.offerPoint.jobName2,
            },
          }),
          _vm._v(" "),
          !_vm.isCompanyStaffAccess
            ? _c("job-content-table-outline", {
                attrs: {
                  title: "対象学歴",
                  value: _vm.jobCategorySettings.offerPoint.educationTarget,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isCompanyStaffAccess
            ? _c(
                "job-content-table-outline",
                {
                  attrs: {
                    title: "年齢",
                    value: _vm.jobCategorySettings.offerPoint.ageFromTo,
                  },
                },
                [
                  _c("br"),
                  _vm._v(" "),
                  _c("a", { on: { click: _vm.openBossSAgeRegulation } }, [
                    _vm._v("［PDF］年齢制限の禁止について"),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isCompanyStaffAccess
            ? _c("job-content-table-outline", {
                attrs: {
                  title: "年収",
                  value: _vm.jobCategorySettings.offerPoint.annualIncomeFromTo,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: {
              title: "外部表示用職種名",
              value: _vm.jobCategorySettings.offerPoint.externalJobName,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "会社について" } },
        [
          _c(
            "job-content-table-outline",
            {
              attrs: {
                title: "正式社名",
                value: _vm.jobCategorySettings.aboutCompany.formalName,
              },
            },
            [
              _c("br"),
              _vm._v(" "),
              _c("span", { staticClass: "notice" }, [
                _vm._v("※支店名、事業部名、グループ名等の入力不可。"),
              ]),
              _vm._v(" "),
              _vm.jobCategorySettings.aboutCompany.isVisibleInGoogle
                ? _c(
                    "span",
                    {
                      staticClass: "notice",
                      attrs: { "data-test": "isVisibility" },
                    },
                    [_vm._v("※提携サイト掲載時にこちらの社名が使用されます。")]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            {
              attrs: {
                title: "表示用社名",
                value: _vm.jobCategorySettings.aboutCompany.displayName,
              },
            },
            [
              _c("br"),
              _vm._v(" "),
              !_vm.jobCategorySettings.aboutCompany.isVisibleInGoogle
                ? _c("span", { staticClass: "notice" }, [
                    _vm._v("※提携サイト掲載時にこちらの社名が使用されます。"),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: {
              title: "業種名",
              value: _vm.jobCategorySettings.aboutCompany.businessName,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("job-content-table", {
        attrs: { title: "設定済PRコード一覧" },
        scopedSlots: _vm._u(
          [
            !_vm.isCompanyStaffAccess
              ? {
                  key: "title",
                  fn: function () {
                    return [
                      _vm._v("\n      ("),
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openBossSPRCodes()
                            },
                          },
                        },
                        [_vm._v("すべてのPRコード")]
                      ),
                      _vm._v(")\n    "),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "default",
              fn: function () {
                return [
                  _c("job-content-table-outline", {
                    attrs: {
                      title: "アピールポイント",
                      value:
                        _vm.jobCategorySettings.configuredPrContents
                          .normalPrContents,
                    },
                  }),
                  _vm._v(" "),
                  _c("job-content-table-outline", {
                    attrs: {
                      title: "特集用検索コード",
                      value:
                        _vm.jobCategorySettings.configuredPrContents
                          .uraPrContents,
                    },
                  }),
                  _vm._v(" "),
                  _c("job-content-table-outline", {
                    attrs: {
                      title: "エンジニア系特集用検索コード",
                      value:
                        _vm.jobCategorySettings.configuredPrContents
                          .uraEngineerPrContents,
                    },
                  }),
                  _vm._v(" "),
                  _c("job-content-table-outline", {
                    attrs: {
                      title: "サービス・販売系特集用検索コード",
                      value:
                        _vm.jobCategorySettings.configuredPrContents
                          .uraServicePrContents,
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "専用応募フォーム" } },
        [
          _c("job-content-table-outline", {
            attrs: {
              title: "設定URL",
              value: _vm.jobCategorySettings.applyUrl,
            },
            scopedSlots: _vm._u(
              [
                _vm.jobCategorySettings.applyUrl
                  ? {
                      key: "body",
                      fn: function () {
                        return [
                          _c("a", {
                            staticClass: "pega-break text-underline",
                            attrs: {
                              href: _vm.jobCategorySettings.applyUrl,
                              rel: "nofollow",
                              target: "blank",
                            },
                            domProps: {
                              textContent: _vm._s(
                                _vm.jobCategorySettings.applyUrl
                              ),
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: _vm.questionTitle } },
        _vm._l([1, 2, 3], function (index) {
          return _c("job-content-table-outline", {
            key: "question-" + index,
            attrs: {
              title: "独自質問" + index,
              value: _vm.questionItems["question" + index],
            },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "情報提供" } },
        [
          _c("job-content-table-outline", {
            attrs: {
              title: "外部連携データ",
              value: _vm.jobCategorySettings.providedInfo,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }